import type { AllRouteEndpoints } from "../routeTypes";

export const engagementApiSegmentCohortsId = "/engagement/api/segment_cohorts/:id";

export const engagementApiSegmentCohortsIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/api/segment_cohorts",
  "/engagement/api/segment_cohorts/:id",
];

export const engagementApiSegmentCohorts = "/engagement/api/segment_cohorts";

export const engagementApiSegmentCohortsCacheKeys: AllRouteEndpoints[] = ["/engagement/api/segment_cohorts"];

export const engagementApiSegmentCohortsIdRefresh = "/engagement/api/segment_cohorts/:id/refresh";
